module.exports = {"533423101":"保和镇","533423102":"叶枝镇","533423103":"塔城镇","533423201":"永春乡","533423202":"攀天阁乡","533423203":"白济汛乡","533423204":"康普乡","533423205":"巴迪乡","533423206":"中路乡","533423207":"维登乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533423.json
// module id = 2672
// module chunks = 0